import { Banner } from '@postscript/components';
import { useGetInvoicingSettings } from 'components/billing/context/useBilling';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';

const StyledBanner = styled(Banner)`
  p {
    font: var(--body-text-x-small);
  }
`;

export default function ManualPaymentIndicator(
  props: HTMLAttributes<HTMLDivElement>,
): JSX.Element | null {
  const { data: invoicingSettings } = useGetInvoicingSettings();

  if (!invoicingSettings?.manualPayments) {
    return null;
  }

  return (
    <StyledBanner
      variant="guidance"
      bodyText="Your shop is sending manual payments via ACH or wire transfer. You can add an optional backup payment method."
      {...props}
      data-testid="banner"
    />
  );
}
